import type { PValueCriteria } from '../components/p-value-field/types';

export function getDifficultyCriteria(criteria: PValueCriteria[], pValue: number | null) {
  return criteria.find(
    (criterion) => (pValue || pValue === 0) && pValue >= criterion.min && pValue <= criterion.max,
  );
}
